export const getClassNames = (classes, props): string => {
  const classNames = [classes.base || ''];

  Object.keys(props).forEach((key) => {
    if (typeof props[key] === 'boolean' && props[key]) {
      classNames.unshift(classes[key] || '');
    } else {
      classNames.unshift(classes[key][props[key]] || '');
    }
  });

  return classNames
    .filter((value: string) => value !== '')
    .join(' ')
    .trim();
};
